import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { map, switchMap } from 'rxjs/operators';
import { AuthSelectors } from '../store/auth/auth.selectors';
import { AuthActions } from '../store/auth/auth.actions';

export function isAuthenticatedGuard(): CanActivateFn {
  return () => {
    const store: Store = inject(Store);
    const router: Router = inject(Router);

    return store.select(AuthSelectors.isAuthenticated).pipe(
      switchMap((isLogged: boolean) => {
        return isLogged
          ? store.dispatch(AuthActions.GetCurrentLogged).pipe(map(() => true))
          : store.dispatch(AuthActions.Logout).pipe(map(() => false));
      }),
      map((isLogged: boolean) => {
        return isLogged ? true : router.parseUrl('/auth/login');
      })
    );
  };
}
